import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { SoftSkillConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { SoftSkillService } from './api/softSkill.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class SoftSkillApiModule {
    public static forRoot(configurationFactory: () => SoftSkillConfiguration): ModuleWithProviders<SoftSkillApiModule> {
        return {
            ngModule: SoftSkillApiModule,
            providers: [ { provide: SoftSkillConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: SoftSkillApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('SoftSkillApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
